import axios from "axios";
import Cookies from 'js-cookie';

const http = new axios.create({
    baseURL: process.env.VUE_APP_URL_API
});

const httpMethod = {
    get(url, options = {}) {
      let token = Cookies.get('TOKEN_LOGIN');
        if (!token) {
            return Promise.reject("No access token.");
        }

        return http
            .get(url, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data);
    },
    post(url, data = null, options = {}) {
      let token = Cookies.get('TOKEN_LOGIN')
        if (!token) {
            return Promise.reject("No access token.");
        }

        return http
            .post(url, data, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data)
    },
    put(url, data = null, options = {}) {
      let token = Cookies.get('TOKEN_LOGIN')
        if (!token) {
            return Promise.reject("No access token.");
        }

        return http
            .put(url, data, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data);
    },
    delete(url, options = {}) {
      let token = Cookies.get('TOKEN_LOGIN')
        if (!token) {
            return Promise.reject("No access token.");
        }

        return http
            .delete(url, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.data);
    }
};

export default httpMethod;
